import styled from 'styled-components';

import { namedBreakpoints, transition } from 'theme';

export const TileGridBlockTileContainer = styled.div`
  transition: all ${transition};

  @media (min-width: ${namedBreakpoints.smUp}) {
    &:hover,
    &:focus {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      h4 {
        text-decoration: underline;
      }
    }
  }
`;
